<!-- @format -->

<div aria-labelledby="student-profile-enrolments-tab" id="enrolments" role="tabpanel" tabindex="0">
  <h2>{{ "PROFILE.ENROLMENT.TITLE" | transloco }}</h2>
  @if (sortedRows$ | async; as rows) {
    @if (rows?.length > 0) {
      <table class="table styled-table">
        <caption>{{ "PROFILE.ENROLMENT.CAPTION" | transloco }}</caption>
        <thead>
          <tr>
            <th>
              <sis-sortable-table-column-header
                name="{{ 'PROFILE.ENROLMENT.STUDY_MODULE' | transloco }}"
                column="name"
                [(reverse)]="this.sorting$.value.reverse"
                [orderKey]="this.sorting$.value.sortKey"
                (orderKeyChange)="sortBy('name')"
                data-cy="enrolments-sort-by-cu-name">
              </sis-sortable-table-column-header>
            </th>
            <th class="without-sorter">
              {{ "PROFILE.ENROLMENT.CODE" | transloco }}
            </th>
            <th>
              <sis-sortable-table-column-header
                name="{{ 'PROFILE.ENROLMENT.CREDITS' | transloco }}"
                column="credits.min"
                [(reverse)]="this.sorting$.value.reverse"
                [orderKey]="this.sorting$.value.sortKey"
                (orderKeyChange)="sortBy('credits.min')"
                data-cy="enrolments-sort-by-credits">
              </sis-sortable-table-column-header>
            </th>
            <th>
              <sis-sortable-table-column-header
                name="{{ 'PROFILE.ENROLMENT.STATUS' | transloco }}"
                column="state"
                [(reverse)]="this.sorting$.value.reverse"
                [orderKey]="this.sorting$.value.sortKey"
                (orderKeyChange)="sortBy('state')"
                data-cy="enrolments-sort-by-state">
              </sis-sortable-table-column-header>
            </th>
            <th class="without-sorter">{{ "PROFILE.ENROLMENT.ASSESSMENT_ITEM" | transloco }}</th>
            <th class="without-sorter">{{ "PROFILE.ENROLMENT.COURSE_UNIT_REALISATION" | transloco }}</th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows; track getProfileEnrolmentRowEnrolmentId($index, row)) {
            <tr data-cy="enrolment-row">
              <td [class.sorted-cell]="getSortKey() === 'name'" data-cy="enrolment-cu-name">
                {{ row.courseUnitName | localizedString }}
              </td>
              <td data-cy="enrolment-code">
                {{ row.code }}
              </td>
              <td [class.sorted-cell]="getSortKey() === 'credits.min'" data-cy="enrolment-credits">
                {{ row.credits | creditRange }}
              </td>
              <td [class.sorted-cell]="getSortKey() === 'state'" data-cy="enrolment-state">
                @switch (row.enrolmentState) {
                  @case ("ENROLLED") {
                    <sis-icon [icon]="'check'" [color]="'success'"></sis-icon>
                  }
                  @case ("REJECTED") {
                    <sis-icon [icon]="'fail'" [color]="'danger'"></sis-icon>
                  }
                  @case ("INVALID") {
                    <sis-icon [icon]="'alert'" [color]="'danger'"></sis-icon>
                  }
                  @default {
                    <sis-icon [icon]="'hourglass'" [color]="'default'"></sis-icon>
                  }
                }
                <span>{{ "ENROLMENT_STATE." + row.enrolmentState | transloco }}</span></td
              >
              <td data-cy="enrolment-ai-name">
                {{ row.assessmentItemName | localizedString }}
              </td>
              <td data-cy="endolment-cur-name">
                {{ row.courseUnitRealisationName | localizedString }}
                @if (row.courseUnitRealisationFlowState === "CANCELLED") {
                  <sis-tiny-badge [flowState]="row.courseUnitRealisationFlowState">
                    {{ "RESOLVED_FLOWS_STATE." + row.courseUnitRealisationFlowState | transloco }}
                  </sis-tiny-badge>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <p class="guidance">{{ "PROFILE.ENROLMENT.NO_ENROLMENTS" | transloco }}</p>
    }
  } @else {
    <div class="spinner-border" role="status">
      <span class="visually-hidden">{{ "PROFILE.ENROLMENT.LOADING" | transloco }}</span>
    </div>
  }
</div>
